<div class="d-flex w-100 justify-content-between">
	<span class="created-by">© 2020-{{currentYear}} - Fireball Server</span>
	<span>v{{version}}</span>
</div>
